<template lang="pug">
  v-tooltip(bottom)
    template(v-slot:activator="{ on, attrs }")
        div.d-flex.align-center.mr-2(v-bind="attrs" v-on="on")
            span.legendCircle.mr-1.noData(:style="{'background-color': color}")
            span.caption(v-text="legendTitle")
    span(v-text="tooltipText") 
</template>

<script>
export default {
  name: "Legend",
  props: {
    legendTitle: {
      type: String,
      required: true
    },
    tooltipText: {
      type: String,
      required: true
    },
    color: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.legendCircle {
  width: 10px;
  height: 10px;
  background-color: black;
  border-radius: 100%;
}
</style>